module.exports = __webpack_public_path__ + "media/notre_mission/background-044548b1.png";